mutation ResetGiveaway($giveawayId: ID!) {
  giveaway: StreamToolsResetGiveaway(giveawayId: $giveawayId) {
    giveawayId
    status
    entrantCount
    hasDraw
    startedAt
    closedAt
    publishedAt
    version
    winners {
      login
      displayName
      rank
      kind
    }
  }
}
